import { render, staticRenderFns } from "./newstudent.vue?vue&type=template&id=42360cfe&"
import script from "./newstudent.vue?vue&type=script&lang=js&"
export * from "./newstudent.vue?vue&type=script&lang=js&"
import style0 from "./newstudent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports